import React from 'react';
import Head from 'next/head';

import ScreenTopBar from 'legacy/components/ScreenTopBar';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import BlurredBackgroundSection from 'components/BlurredBackgroundSection';
import CenteredContainer from 'components/CenteredContainer';

import DashboardHeader from '../components/new/DashboardHeader';
import DashboardBottomBar from '../components/DashboardBottomBar';
import DashboardSkeleton from '../components/DashboardSkeleton';
import { useEventDashboard } from '../context';
import EventMenu from '../components/new/EventMenu';
import EventFinancialsSummary from '../components/new/EventFinancialsSummary';

import KeyMetricsFinancials from '../components/new/KeyMetricsFinancials';
// import TicketTiersSales from '../components/new/TicketTiersSales';

const EventFinancialsContent = () => {
  const {
    data: { event, eventAnalytics },
    goBack,
    toggleManageEventModal
  } = useEventDashboard();

  if (!event || !eventAnalytics) {
    return <DashboardSkeleton />;
  }

  return (
    <>
      <Head>
        <title>{event.title}&apos;s Analytics | Bounce</title>
      </Head>
      <ScreenTopBar
        title="Event financials"
        onMenuClick={toggleManageEventModal}
        onBack={goBack}
        wideContent
      >
        {event.isDraft && (
          <div className="flex-1 justify-end flex pr-2">
            <div className="border-1 rounded-full px-3 items-center flex">
              Draft
            </div>
          </div>
        )}
      </ScreenTopBar>
      <div className="md:pt-[46px] -mt-[41px] md:mt-0 pb-20">
        <div className="relative z-1">
          <FadeIn>
            <BlurredBackgroundSection imageUrl={event.photo?.url}>
              <CenteredContainer wideContent>
                <div className="pt-5 md:pt-11">
                  <DashboardHeader />
                  <EventMenu isOrganizer={event.isOrganizer} />
                </div>
              </CenteredContainer>
            </BlurredBackgroundSection>
            <CenteredContainer wideContent>
              <div className="pt-11 gap-11 flex flex-col">
                <EventFinancialsSummary />
                <KeyMetricsFinancials />
                {/* <TicketTiersSales /> */}
              </div>
            </CenteredContainer>
          </FadeIn>
        </div>
      </div>
      <DashboardBottomBar />
    </>
  );
};

export default EventFinancialsContent;
